import {
  SET_TOKEN,
  SET_USER_ID,
  SET_CHEF,
  BECOME_CHEF,
  UPDATE_STEP,
  FORGOT_PASSWORD,
  SET_FORCE_CHANGE_PASSWORD,
  SHOW_BECOME_CHEF_MSG,
  SET_INIT_HOME_LIST,
  SET_BOOKINGS_NAV_STEP,
  SET_RETURN_URL
} from "../stateConstants";

import { client } from "../../config/apollo";
import { MUT_FORGOT_PASSWORD } from "../../graphql/mutations/auth";
import { setViewAsDiner } from '../user';
import {clearChefFilters, clearDishFilters} from "../chefs";

const initialState = {
  token: null,
  userId: null,
  isChef: null,
  becomeChef: false,
  step: 8,
  fpassword: null,
  forceChangePassword: false,
  showBecomeChefMsg: 'no',
  initHomeList: 'chef',
  bookingNavStep: 1,
  returnUrl: null
};

const reducer = (state = initialState, action = {}) => {
  switch (action.type) {
    default:
      return state;

    case FORGOT_PASSWORD:
      return {
        ...state,
        fpassword: action.result
      };

    case SET_USER_ID:
      return {
        ...state,
        userId: action.result
      };

    case SET_TOKEN:
      return {
        ...state,
        token: action.result
      };

    case SET_CHEF:
      return {
        ...state,
        isChef: action.result
      };

    case BECOME_CHEF:
      return {
        ...state,
        becomeChef: action.result
      };
    case UPDATE_STEP:
      return {
        ...state,
        step: action.result
      };

    case SET_FORCE_CHANGE_PASSWORD:
      return {
        ...state,
        forceChangePassword: action.result
      };

    case SET_INIT_HOME_LIST:
      return {
        ...state,
        initHomeList: action.result,
      };

    case SHOW_BECOME_CHEF_MSG:
      return {
        ...state,
        showBecomeChefMsg: action.payload
      };

    case SET_BOOKINGS_NAV_STEP:
      return {
        ...state,
        bookingNavStep: action.payload
      };

    case SET_RETURN_URL:
      return {
        ...state,
        returnUrl: action.payload
      };
  }
};

export default reducer;

export const setInitHomeList = (value) => {
  return dispatch => {
    dispatch({
      type: SET_INIT_HOME_LIST,
      result: value
    });
  };
};

export const logoutUser = () => {
  return dispatch => {
    window.localStorage.removeItem("zg-cc-auth-userId");
    window.localStorage.removeItem("ccZestyAuthToken");
    window.localStorage.removeItem("zg-cc-auth-isChef");
    window.localStorage.removeItem("chefStep");
    dispatch({
      type: SET_USER_ID,
      result: null
    });
    dispatch(setViewAsDiner(false));
    dispatch(clearChefFilters());
    dispatch(clearDishFilters());
    dispatch(setInitHomeList('chef'));
  };
};

export const clearLocalStorage = () => {
    window.localStorage.removeItem("zg-cc-auth-userId");
    window.localStorage.removeItem("ccZestyAuthToken");
    window.localStorage.removeItem("zg-cc-auth-isChef");
    window.localStorage.removeItem("chefStep");
};

export const setUserId = id => {
  return dispatch => {
    window.localStorage.setItem("zg-cc-auth-userId", id);

    dispatch({
      type: SET_USER_ID,
      result: id
    });
  };
};

export const getUserId = () => {
  return dispatch => {
    let userId = null;

    if (localStorage.hasOwnProperty("zg-cc-auth-userId")) {
      userId = window.localStorage.getItem("zg-cc-auth-userId");
    }

    dispatch({
      type: SET_USER_ID,
      result: userId
    });
  };
};

export const setAuthToken = token => {
  const authToken = window.localStorage.getItem("ccZestyAuthToken");
  if (!authToken) {
    window.localStorage.setItem("ccZestyAuthToken", token);
  }

  return dispatch => {
    dispatch({
      type: SET_TOKEN,
      result: token
    });
  };
};

export const setForceChangePassword = changePassword => {
  window.localStorage.setItem("ccZestyForceChangPassword", changePassword);
  if (!changePassword) {
    window.localStorage.removeItem('ccZestyForceChangPassword');
  }
  return dispatch => {
    dispatch({
      type: SET_FORCE_CHANGE_PASSWORD,
      result: changePassword
    });
  };
};

export const setIsChef = setChef => {
  return dispatch => {
    window.localStorage.setItem("zg-cc-auth-isChef", setChef);
    dispatch({
      type: SET_CHEF,
      result: setChef
    });
  };
};

export const getIsChef = () => {
  return dispatch => {
    let isChef = window.localStorage.getItem("zg-cc-auth-isChef");
    isChef = isChef === 'true';

    dispatch({
      type: SET_CHEF,
      result: isChef
    });
  };
};

export const setBecomeChef = setChef => {
  return dispatch => {
    dispatch({
      type: BECOME_CHEF,
      result: setChef
    });
  };
};

export const setChefStep = step => {
  return dispatch => {
    window.localStorage.setItem("chefStep", step);
    dispatch({
      type: UPDATE_STEP,
      result: step
    });
  };
};

export const getChefStep = () => {
  return dispatch => {
    const chefStep = window.localStorage.getItem("chefStep");
    dispatch({
      type: UPDATE_STEP,
      result: chefStep
    });
  };
};

export const forogotPassword = emailId => {
  return dispatch => new Promise((resolve, reject) => {
    client
      .mutate({
        mutation: MUT_FORGOT_PASSWORD,
        variables: {
          emailId
        }
      })
      .then(response => {
        dispatch({
          type: FORGOT_PASSWORD,
          result: response
        });
        resolve(response);
      })
      .catch(err => {
        reject(err);
      });
  });
};

export const showBecomeMsg = status => {
  return dispatch => {
    dispatch({
      type: SHOW_BECOME_CHEF_MSG,
      payload: status
    });
  };
};

export const setBookingNavStep = step => {
  return dispatch => dispatch({
    type: SET_BOOKINGS_NAV_STEP,
    payload: step
  });
};

export const setReturnUrl = payload => {
  return dispatch => dispatch({
    type: SET_RETURN_URL,
    payload
  });
};
